export default {
    AR: 'AR',
    PE: 'PE',
};
